<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Blacklisted User</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.userId" label="User ID"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="editedItem.reason" label="Reason"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field readonly v-model="editedItem.updatedDate" label="Updated"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field readonly v-model="editedItem.createdDate" label="Created"></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.firstName" label="First Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.lastName" label="Last Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="editedItem.mobileNumber" label="Mobile Number"></v-text-field>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-expansion-panel v-model="userSearchPanelModel">
      <v-expansion-panel-content :key="userSearchPanel"> -->
        <template>
          <!-- <div slot="header" class="headline">{{ userSearchTitle }}</div>
          <v-form>
            <v-container>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                  @click:clear="searchCleared()"
                ></v-text-field>
              </v-flex>
            </v-container>
          </v-form> -->

          <v-card>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="userBlacklist"
              :search="search"
              :loading="loadingUsers"
              item-key="userId"
              class="elevation-1"
              :rows-per-page="rowsPerPage"
              :items-per-page-options="rppItems"
            >
              <template slot="item" slot-scope="props">
                <!-- <tr @click="editItem(props.item)"> -->
                <tr>
                  <td class="text-xs-right">{{ props.item.userId }}</td>
                  <td class="text-xs-left">{{ props.item.reason }}</td>
                  <td class="text-xs-left">{{ props.item.updatedDate }}</td>
                  <td class="text-xs-left">{{ props.item.createdDate }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon small @click="deleteItem(props.item)">delete</v-icon>
                    <v-icon :disabled="true" small @click="deleteItem(props.item)">chevron_left</v-icon>
                    <v-icon small @click="deleteItem(props.item)">chevron_right</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
          <v-spacer></v-spacer>
        </template>
      <!-- </v-expansion-panel-content>
    </v-expansion-panel> -->

    <!-- <div>
      <v-tabs slot="extension" v-model="model" color="blue" slider-color="yellow">
        <v-tab :key="userDetailTab">Details</v-tab>
        <v-tab :key="userJarTab">Jars</v-tab>
        <v-tab :key="userNotificationTab">Notifications</v-tab>
        <v-tab :key="userRewardTab">Rewards</v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-tabs-items v-model="model">
        <v-tab-item :key="userDetailTab">
          <v-expansion-panel v-model="userLoginHistoryPanelModel">
            <v-expansion-panel-content :key="loginHistoryPanel">
              <template>
                <div slot="header" class="xs8" v-html="loginHistoryTitle">{{ loginHistoryTitle }}</div>
                <v-card flat>
                  <userLoginHistory @update:title="loginHistoryTitle = getLoginHistoryTitle()" :user="selected[0]" ref="loginHistory" class="tab"></userLoginHistory>
                </v-card>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <div>
            <template v-if="isUserSelected()">
              <v-container fluid grid-list-md>
                <v-flex xs48 sm48>
                  <v-card>
                    <v-container fluid grid-list-md>
                      <v-layout row wrap>
                        <v-flex v-bind="{ [`xs4`]: true }">
                          <userDetailSummary v-if="isUserSelected()" :user="selected[0]" ref="userDetailSummaryRef"></userDetailSummary>
                        </v-flex>
                        <v-flex v-bind="{ [`xs4`]: true }">
                          <userVaultSummary v-if="isUserSelected()" :user="selected[0]" ref="userVautSummaryRef"></userVaultSummary>
                        </v-flex>
                        <v-flex v-bind="{ [`xs4`]: true }">
                          <userContestSummary v-if="isUserSelected()" :user="selected[0]" ref="userContestSummaryRef"></userContestSummary>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-container>
            </template>
          </div>
        </v-tab-item>
        <v-tab-item :key="userJarTab">
          <v-card flat v-if="isUserSelected()">
            <jars :user="selected[0]" ref="userJars" class="tab"></jars>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userNotificationTab">
          <v-card flat>
            <notifications ref="notificationTab" class="tab"></notifications>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="userRewardTab">
          <v-card flat>
            <rewards :user="selected[0]" ref="rewardTab" class="tab"></rewards>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div> -->
  </div>
</template>

<script>
// import notifications from '@/components/Notifications.vue'
// import jars from '@/components/UserJars.vue'
// import rewards from '@/components/UserRewards.vue'
// import userLoginHistory from '@/components/UserLoginHistory.vue'
// import userVaultSummary from '@/components/UserVaultSummary.vue'
// import userDetailSummary from '@/components/UserDetailSummary.vue'
// import userContestSummary from '@/components/UserContestSummary.vue'
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: ['auth'],

  data: () => ({
    model: null,
    // loginHistoryTitle: '',
    // userSearchPanelModel: null,
    // userSearchPanel: null,
    // userLoginHistoryPanelModel: null,
    // loginHistoryPanel: null,
    // userNotificationTab: null,
    // userJarTab: null,
    // userDetailTab: null,
    // userRewardTab: null,
    loadingUsers: false,
    search: '',
    rppItems: [
      5,
      20,
      40,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 5,
    selected: [],
    dialog: false,
    // loginHistoryModel: false,
    headers: [
      {
        text: 'User ID',
        align: 'left',
        sortable: false,
        value: 'userId'
      },
      { text: 'Reason', value: 'reason' },
      { text: 'Updated Date', value: 'updatedDate' },
      { text: 'Created Date', value: 'createdDate' }
    ],
    userBlacklist: [],
    editedIndex: -1,
    editedItem: {
      userId: '',
      reason: 0,
      udpatedDate: 0,
      createdDate: 0
    },
    defaultItem: {
      userId: '',
      reason: 0,
      udpatedDate: 0,
      createdDate: 0
    }
  }),

  components: {
    // notifications,
    // rewards,
    // userLoginHistory,
    // jars,
    // userVaultSummary,
    // userDetailSummary,
    // userContestSummary
  },

  computed: {
    // formTitle () {
    //   return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    // },
    // userSearchTitle () {
    //   return this.selected === undefined || this.selected.length < 1
    //     ? 'Select a User Below'
    //     : this.selected[0].userId +
    //         ' - ' +
    //         this.selected[0].firstName +
    //         ' ' +
    //         this.selected[0].lastName +
    //         ' (' +
    //         this.selected[0].quberUserName +
    //         ')'
    // }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    // async selectUser (a) {
    //   this.selected = [a]
    //   this.userSearchPanelModel = undefined
    //   this.$refs.notificationTab.ids = a.userId
    // },
    // isUserSelected () {
    //   return (
    //     this.selected !== undefined &&
    //     this.selected != null &&
    //     this.selected.length > 0
    //   )
    // },
    // searchCleared () {
    //   this.selected = []
    //   this.$refs.notificationTab.ids = ''
    //   this.lastLogin = null
    // },
    async initialize () {
      this.loadingUsers = true
      this.userSearchPanelModel = 0
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/blacklist`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.userBlacklist = getResponse.data
      this.loadingUsers = false
    },

    editItem (item) {
      this.editedIndex = this.userBlacklist.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem (item) {
      const index = this.userBlacklist.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/${item.userId}/blacklist`

        var getResponse = await rh.default.delete(endpoint, true).catch(e => {
          this.errors.push(e)
        })

        this.userBlacklist.splice(index, 1)
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    // hideHistory () {
    //   this.loginHistoryModel = false
    // },
    // toggleHistory () {
    //   this.loginHistoryModel = !this.loginHistoryModel
    // },

    async save () {
      if (this.editedIndex > -1) {
        Object.assign(this.userBlacklist[this.editedIndex], this.editedItem)
      } else {
        this.userBlacklist.push(this.editedItem)
      }
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/blacklist`

      var getResponse = await rh.default.post(endpoint, this.editedItem, true).catch(e => {
        this.errors.push(e)
      })

      this.close()
    }
    // getLoginHistoryTitle () {
    //   if (this.$refs.loginHistory === undefined || this.$refs.loginHistory === null) return ''
    //   var title = ''
    //   var lastLogin = this.$refs.loginHistory.history[0]
    //   if (
    //     lastLogin === null ||
    //     lastLogin === undefined ||
    //     lastLogin.createdDate === undefined
    //   ) {
    //     if (this.selected != null && this.selected.length > 0) {
    //       title = 'User has not logged in'
    //     }
    //   } else {
    //     title =
    //       'Last logged into <b>Quber version ' +
    //       lastLogin.quberVersion +
    //       '</b> on <b>' +
    //       moment(String(lastLogin.createdDate)).format(
    //         'MM/DD/YYYY hh:mm:ss'
    //       ) +
    //       '</b> using <b>' +
    //       lastLogin.deviceType +
    //       '</b> OS version <b>' +
    //       lastLogin.osVersion +
    //       '</b>'
    //   }
    //   return title
    // }
  }
}
</script>
